"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.password.placeholder': 'Inserisci password',
};
